(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ivfu6", function(module, exports) {


(parcelRequire("6iGGj")).register((parcelRequire("dExHe")).getBundleURL('iwyoR'), JSON.parse("[\"iwyoR\",\"group-selection.3e3c9a2a.js\",\"1jNHP\",\"ua.6704cf4e.js\"]"));

});
parcelRegister("6iGGj", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $4965882e7cef3f17$export$6503ec6e8aabbaf; }, function (v) { return $4965882e7cef3f17$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $4965882e7cef3f17$export$f7ad0328861e2f03; }, function (v) { return $4965882e7cef3f17$export$f7ad0328861e2f03 = v; });
var $4965882e7cef3f17$export$6503ec6e8aabbaf;
var $4965882e7cef3f17$export$f7ad0328861e2f03;
"use strict";
var $4965882e7cef3f17$var$mapping = new Map();
function $4965882e7cef3f17$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$4965882e7cef3f17$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $4965882e7cef3f17$var$resolve(id) {
    var resolved = $4965882e7cef3f17$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$4965882e7cef3f17$export$6503ec6e8aabbaf = $4965882e7cef3f17$var$register;
$4965882e7cef3f17$export$f7ad0328861e2f03 = $4965882e7cef3f17$var$resolve;

});

parcelRegister("dExHe", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $9f09262f1ec62ba9$export$bdfd709ae4826697; }, function (v) { return $9f09262f1ec62ba9$export$bdfd709ae4826697 = v; });
var $9f09262f1ec62ba9$export$bdfd709ae4826697;
var $9f09262f1ec62ba9$export$c9e73fbda7da57b6;
var $9f09262f1ec62ba9$export$5a759dc7a1cfb72a;
"use strict";
var $9f09262f1ec62ba9$var$bundleURL = {};
function $9f09262f1ec62ba9$var$getBundleURLCached(id) {
    var value = $9f09262f1ec62ba9$var$bundleURL[id];
    if (!value) {
        value = $9f09262f1ec62ba9$var$getBundleURL();
        $9f09262f1ec62ba9$var$bundleURL[id] = value;
    }
    return value;
}
function $9f09262f1ec62ba9$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $9f09262f1ec62ba9$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $9f09262f1ec62ba9$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $9f09262f1ec62ba9$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$9f09262f1ec62ba9$export$bdfd709ae4826697 = $9f09262f1ec62ba9$var$getBundleURLCached;
$9f09262f1ec62ba9$export$c9e73fbda7da57b6 = $9f09262f1ec62ba9$var$getBaseURL;
$9f09262f1ec62ba9$export$5a759dc7a1cfb72a = $9f09262f1ec62ba9$var$getOrigin;

});


parcelRegister("drEiU", function(module, exports) {


module.exports = (parcelRequire("1JviA"))((parcelRequire("6iGGj")).resolve("1jNHP")).then(()=>parcelRequire('52xGG'));

});
parcelRegister("1JviA", function(module, exports) {
"use strict";

var $6Xw4v = parcelRequire("6Xw4v");
module.exports = $6Xw4v(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("6Xw4v", function(module, exports) {
"use strict";
var $51112182a3d8fae4$var$cachedBundles = {};
var $51112182a3d8fae4$var$cachedPreloads = {};
var $51112182a3d8fae4$var$cachedPrefetches = {};
function $51112182a3d8fae4$var$getCache(type) {
    switch(type){
        case 'preload':
            return $51112182a3d8fae4$var$cachedPreloads;
        case 'prefetch':
            return $51112182a3d8fae4$var$cachedPrefetches;
        default:
            return $51112182a3d8fae4$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $51112182a3d8fae4$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});





parcelRequire("ivfu6");
})();
const main = async ()=>{
    try {
        const { default: UA } = await parcelRequire94c2("drEiU");
        // Call it based on UA
        const ua = new UA();
        switch(true){
            case ua.os === UA.OS.Android:
                window.location.href = 'users-android.html';
                break;
            case ua.os === UA.OS.iOS:
                window.location.href = 'users-ios.html';
                break;
            case ua.browser === UA.Browser.Firefox:
                window.location.href = 'users-firefox.html';
                break;
            case ua.browser === UA.Browser.Chromium:
                window.location.href = 'users-chrome.html';
                break;
            default:
                break;
        }
    } catch (error) {
        console.warn('Failed to load UA Detection:', error);
    }
};
main();

//# sourceMappingURL=group-selection.3e3c9a2a.js.map
